module.exports = "/images/RO.png?d1b456a0e20bc114cbf088c6777ea726";